import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import './Login.css';
import logo from "../image/bookly_logo.png";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(login({ email, password, targetRole: 'user' }, navigate));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 register-background">
      <div className="register-container shadow rounded p-5 text-center">
        <img src={logo} alt="Bookly Logo" className="mb-4 login-logo-img" />
        <h4 className="mb-4 text-secondary font-weight-bold">Espace Client</h4>

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Adresse Email</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="votre.email@exemple.com"
              value={email}
              className="input-field"
              required
            />
          </Form.Group>

          <Form.Group className="mb-4 text-start">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Votre mot de passe"
              value={password}
              className="input-field"
              required
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 btn-submit mb-3">
            Se connecter
          </Button>

          <div className="d-flex flex-column gap-2 mt-4 text-muted" style={{ fontSize: '13.5px' }}>
            <div className="d-flex justify-content-between">
              <span>Nouveau ? <Link to="/Register">Créer un compte</Link></span>
              <span><Link to="/AdminLogin" className="text-primary font-weight-bold">Accès Admin ➔</Link></span>
            </div>
            <div className="text-center mt-2 border-top pt-2">
              <span>Vous êtes un établissement ? <Link to="/ProviderLogin" className="text-success font-weight-bold">Espace Prestataire ➔</Link></span>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
